import React from 'react';
import WorkpageCard from '../AllWork/WorkpageCard';

const ProjectGrid = (props) => {

    const blok = props.blok

    if (blok.projects.length == 0 || blok.projects == undefined ) return null

    return(
        <section className='width'>

            <h2 className='text-lg lg:text-3xl font-semibold pb-4'>
                {blok.title}
            </h2>
            <ol className='grid lg:grid-cols-2 gap-7 lg:gap-6'>
            {blok.projects.map(project => {
                return(
                    <WorkpageCard key={project.uuid} video={project.content.card_video} image={project.content.card_image} title={project.content.title} copy={project.content.tagline} url={`${project.full_slug}`} mobileLandscape />
                )
            })}
            </ol>

        </section>
    )
}

export default ProjectGrid